module.exports = __webpack_public_path__ + "static/media/logo_tax2win.8af4946d.svg";